import { FC, Dispatch, useEffect, useState } from 'react'
import Modal from '@components/modal'
import {
  StyleCalenderHeaderWrapper,
  StyleActionBtn,
  StyleWeekDaysWrapper,
  StyleWeekDayItem,
  StyleDatesGrid,
  StyleDateItem,
} from './style'
import {
  getDaysInMonth,
  format,
  addMonths,
  subMonths,
  startOfMonth,
  getDay,
} from 'date-fns'
import Svg from '@components/svg'
import Typography from '@components/typography'
interface CalendarProps {
  setVisible: Dispatch<React.SetStateAction<boolean>>
  visible: boolean
  onChange?: (date: any) => void
}
const Calendar: FC<CalendarProps> = ({ setVisible, visible }) => {
  const currentDate = format(new Date(), 'yyyy-MM-dd')
  const weekDays = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ]

  const [currentMonth, setCurrentMonth] = useState<any>()
  const [currentMonthNo, setCurrentMonthNo] = useState(0)
  const [currentYear, setCurrentYear] = useState<any>()
  const [calendarDates, setCalendarDates] = useState<(string | null)[]>([])
  const [selectedDate, setSelectedDate] = useState<Date>(new Date())
  const generateCalendar = (date: Date) => {
    const totalDays = getDaysInMonth(date)
    const month = format(date, 'MMMM')
    const monthNo: any = format(date, 'MM')
    const year = format(date, 'yyyy')
    const startDay = getDay(startOfMonth(date))
    setCurrentMonth(month)
    setCurrentYear(year)
    setCurrentMonthNo(monthNo)
    const daysArray = Array.from({ length: totalDays }, (_, i) =>
      String(i + 1).padStart(2, '0'),
    )
    const paddedArray: (string | null)[] = [
      ...Array(startDay).fill(null),
      ...daysArray,
    ]
    setCalendarDates(paddedArray)
  }

  const handleClickPrev = () => {
    const date = subMonths(selectedDate, 1)
    setSelectedDate(date)
    generateCalendar(date)
  }

  const handleClickNext = () => {
    const date = addMonths(selectedDate, 1)
    setSelectedDate(date)
    generateCalendar(date)
  }

  useEffect(() => {
    generateCalendar(selectedDate)
  }, [])
  return (
    <Modal visible={visible} onClose={() => setVisible(false)} hasCross={false}>
      <StyleCalenderHeaderWrapper>
        <StyleActionBtn onClick={handleClickPrev}>
          <Svg svg="leftArrow" color="primary" />
        </StyleActionBtn>
        <Typography
          content={`${currentMonth}, ${currentYear}`}
          size={16}
          tc="primary"
        />
        <StyleActionBtn onClick={handleClickNext}>
          <Svg svg="rightArrow" color="primary" />
        </StyleActionBtn>
      </StyleCalenderHeaderWrapper>
      <StyleWeekDaysWrapper>
        {weekDays.map((day) => (
          <StyleWeekDayItem key={day}>{day[0]}</StyleWeekDayItem>
        ))}
      </StyleWeekDaysWrapper>
      <StyleDatesGrid>
        {calendarDates.map((day, index) => {
          const date = `${currentYear}-${currentMonthNo}-${day}`
          const isActive = date == currentDate

          return (
            <StyleDateItem isActive={isActive} key={index}>
              {day ? day : ''}
            </StyleDateItem>
          )
        })}
      </StyleDatesGrid>
    </Modal>
  )
}

export default Calendar
